import { UserApi } from "@/api/user.api";
import { $account } from "@/stores/account";
import { useStore } from "@nanostores/react";
import Cookies from "js-cookie";
import { nanoid } from "nanoid";
import { useEffect } from "react";
import { Outlet } from "react-router-dom";

export default function RootLayout() {
  const account = useStore($account);

  useEffect(() => {
    if (!account.isLoggedIn) {
      const guid = Cookies.get("guest_user_id");
      if (!guid) Cookies.set("guest_user_id", nanoid(), { expires: 30 });
      // Background guest registration: nothing reads the reply, so a failure
      // (reload / navigate away / phone locked mid-request) is invisible to the
      // visitor. Swallow it so it stops reaching Sentry as an unhandled
      // rejection (2026-09-26, Michael: pure noise; it is NOT signup).
      UserApi.createGuestUser().catch(() => {});
    }
  }, [account.isLoggedIn]);

  // Hide the HTML initial loader and manage React loader
  useEffect(() => {
    const htmlLoader = document.getElementById("initial-loader");
    if (htmlLoader) {
      htmlLoader.style.display = "none";
    }
  }, []);

  return <Outlet />;
}
